import React from 'react';
import PropTypes from 'prop-types';
import { PasswordExpireBanner } from '@piplapps/pipl-ui';
import { connect } from 'react-redux';
import { LocalStorage } from 'Services/LocalStorageService';
import { AppSelectors } from 'Redux/modules/app/selectors';
import { AppActions } from '../../Redux/modules/app/actions';
import AnalyticsEventNames from '../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsCore from '../../Utils/AnalyticsHandler/AnalyticsCore';
import AppConfig from '../../Config/AppConfig';

const PasswordExpireBannerContainer = (props) => {
  return (
    <PasswordExpireBanner
      redirectUrl={`/${AppConfig.ACCOUNTS_PREFIX}profile/`}
      shouldDisplayPasswordExpireBanner={props.user.shouldDisplayPasswordExpireBanner}
      expirationDate={props.user.passwordExpiration}
      localStorage={LocalStorage}
      dateFormat="YYYY/MM/DD hh:mm:ss"
      onCloseBanner={() => {
        const event = AnalyticsCore.buildEvent({
          eventName: AnalyticsEventNames.CLOSE_PASSWORD_BANNER,
          tracking: props.tracking,
          user: props.user,
        });
        AnalyticsCore.sendEvent(event);
        props.onClickedCloseBanner();
      }}
      onClick={() => {
        const event = AnalyticsCore.buildEvent({
          eventName: AnalyticsEventNames.CHANGE_PASSWORD_FROM_BANNER,
          tracking: props.tracking,
          user: props.user,
        });
        AnalyticsCore.sendEvent(event);
      }}
    />
  );
};

PasswordExpireBannerContainer.propTypes = {
  user: PropTypes.object,
  onClickedCloseBanner: PropTypes.func,
  tracking: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: AppSelectors.userSelector(state),
    tracking: AppSelectors.trackingSelector(state),
  };
};

const mapActionToProps = {
  onClickedCloseBanner: AppActions.closedPasswordBanner,
};

const withConnect = connect(mapStateToProps, mapActionToProps);

export default withConnect(PasswordExpireBannerContainer);
